<script setup>
import { computed } from 'vue';

const props = defineProps({
  step: {
    type: String,
    default: '',
  },
  progress: {
    type: Number,
    default: 0,
  },
});

const stepLabel = computed(() => {
  const stepLabels = {
    starting: 'AGENTS_SIDECAR.LOADER.STARTING',
    gating: 'AGENTS_SIDECAR.LOADER.ANALYZING',
    reader: 'AGENTS_SIDECAR.LOADER.READING',
    responder: 'AGENTS_SIDECAR.LOADER.GENERATING',
    suggester: 'AGENTS_SIDECAR.LOADER.SUGGESTING',
    indexer: 'AGENTS_SIDECAR.LOADER.INDEXING',
    escalation: 'AGENTS_SIDECAR.LOADER.CHECKING',
    searching: 'AGENTS_SIDECAR.LOADER.SEARCHING',
    analyzing: 'AGENTS_SIDECAR.LOADER.ANALYZING',
  };
  return stepLabels[props.step] || 'AGENTS_SIDECAR.LOADER.PROCESSING';
});

const progressPercent = computed(() => Math.round(props.progress * 100));
</script>

<template>
  <div
    class="flex items-center gap-3 p-3 rounded-lg bg-n-alpha-1 border border-n-weak"
  >
    <div class="relative w-8 h-8 flex-shrink-0">
      <div class="absolute inset-0 rounded-full border-2 border-n-weak" />
      <div
        class="absolute inset-0 rounded-full border-2 border-transparent border-t-n-brand animate-spin"
      />
      <div class="absolute inset-0 flex items-center justify-center">
        <span class="i-lucide-sparkles text-sm text-n-brand animate-pulse" />
      </div>
    </div>

    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium text-n-slate-12 truncate">
        {{ $t(stepLabel) }}
      </p>
      <div v-if="progress > 0" class="mt-1">
        <div class="h-1 bg-n-solid-3 rounded-full overflow-hidden">
          <div
            class="h-full bg-n-brand rounded-full transition-all duration-300 ease-out"
            :style="{ width: `${progressPercent}%` }"
          />
        </div>
      </div>
    </div>

    <span class="text-xs text-n-slate-10 font-medium">
      {{ progressPercent }}%
    </span>
  </div>
</template>
